import React, { useState } from 'react';
import { KTSVG } from '../../../../rbts/helpers';
import { CreateModal } from '../_modals/CreateModal';
import { ListGrid } from './ListGrid';
import { useObtenerProveedores } from '../hooks/ProveedorHook';

const View: React.FC = () => {
  // GRID
  const [reloadGrid, setReloadGrid] = useState(Math.random() * 40);
  const [idRow, setIdRow] = useState<number>(0);
  const { data, loadingRequest } = useObtenerProveedores(reloadGrid);

  // MODAL NUEVO EDIT
  const [visivilityModal, setVisivilityModal] = useState(false);
  const addRegister = () => {
    setVisivilityModal(!visivilityModal);
  };
  const editRegister = (id: number) => {
    setIdRow(id);
    setVisivilityModal(!visivilityModal);
  };

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12">
          <div className={`card card-xxl-stretch mb-5 mb-xl-12`}>
            <div className="card-header border-0 pt-5">
              <div className="card-title align-items-start flex-column">
                <div className="space-items-between"></div>
              </div>

              <div
                className="card-toolbar"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                data-bs-trigger="hover"
                title="Nuevo registro"
              >
                <div
                  className="btn btn-sm btn-light-primary"
                  id="kt_toolbar_primary_button"
                  onClick={() => {
                    addRegister();
                  }}
                >
                  <KTSVG
                    path="/media/icons/duotune/arrows/arr075.svg"
                    className="svg-icon-5 svg-icon-gray-500 me-1"
                  />
                  Nuevo
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="row gy-5 g-xl-8">
                <div className="col-xl-12">
                  <ListGrid
                    data={data}
                    loadingGrid={loadingRequest}
                    onEditRegister={editRegister}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CreateModal
        id_row={idRow}
        show={visivilityModal}
        handleClose={(updateGrid: boolean) => {
          if (updateGrid) {
            setReloadGrid(Math.random() * 40);
          }
          setVisivilityModal(!visivilityModal);
          setIdRow(0);
        }}
      ></CreateModal>
    </>
  );
};

export { View };
